import {RouteConfig} from 'vue-router';
import ChallengeComingSoon from '@/components/Challenges/ChallengeComingSoon.vue';
import ChallengeFinished from '@/components/Challenges/ChallengeFinished.vue';
import ChallengeInProgress from '@/components/Challenges/ChallengeInProgress.vue';

export const challengesByStatusRoutes: RouteConfig[] = [
  {
    path: 'in-progress',
    name: 'in-progress-challenges',
    component: ChallengeInProgress,
  },
  {
    path: 'finished',
    name: 'finished-challenges',
    component: ChallengeFinished,
  },
  {
    path: 'coming-soon',
    name: 'coming-soon-challenges',
    component: ChallengeComingSoon,
  },
];
